import React from 'react'

export default () => (
  <section id="video">
      <div className="section_title">
          <p>VIDEO</p>
          <h2>社員の一日を動画で紹介</h2>
      </div>
      <div className="section_contents">
          <div className="video_list">
              <div className="video_item">
                  <div className="video">
                      <iframe width="560" height="315" src="https://www.youtube.com/embed/Akq8RMeKY0Q"
                          title="YouTube video player" frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen=""></iframe>
                  </div>
              </div>
              <div className="video_item">
                  <div className="video">
                      <iframe width="560" height="315" src="https://www.youtube.com/embed/SXokgUzqTnc"
                          title="YouTube video player" frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen=""></iframe>
                  </div>
              </div>
              <div className="video_item">
                  <div className="video">
                      <iframe width="560" height="315" src="https://www.youtube.com/embed/Bwk9yD0-Hy4"
                          title="YouTube video player" frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen=""></iframe>
                  </div>
              </div>
          </div>
      </div>
  </section>
)


// WEBPACK FOOTER //
// ./src/Home/Videos.js